module.exports = __webpack_public_path__ + "img/ca64-400o400o2-dc-5e69-48d2-aec5-2256dcd7f3f6.af6ca0a0-edc7-44c5-a8d6-711973d2a724@2x.a0e5e287.png";